<template>
  <div class="bg-white" style="padding: 20px;">
    <template>
      <el-tabs v-model="activeName" type="card" @tab-click="categoryTabs">
        <el-tab-pane v-for="(category, i) in categorys" :name="category.firstCategoryName" :key="i">
          <span slot="label"><i v-if="category.isCheckConfig" class="el-icon-view"></i> {{ category.firstCategoryName }}</span>
        </el-tab-pane>
      </el-tabs>
    </template>

    <el-collapse v-loading="loading"  v-model="activeNames" @change="handleChange">
      <template v-for="(item, i) in categoryAttrs.lastStageCategoryList">
        <el-collapse-item :title="item.categoryName" :name="i" :key="i">
          <div class="categorys">
            <div class="attrs" v-for="(attrs, x) in item.attrList" :key="x">
              <div class="attr-title">
                <div style="width: 50%;">{{ attrs.attrName }}</div>
                <div><el-checkbox v-model="attrs.isAggregation" :true-label="1" :false-label="0" @change="(e) => setSiteMapConfigAll(e, 'aggregation', i, x)">聚合SEO</el-checkbox></div>
                <div><el-checkbox v-model="attrs.isInternalLink" :true-label="1" :false-label="0" @change="(e) => setSiteMapConfigAll(e, 'internalLink', i, x)">内链</el-checkbox></div>
              </div>
              <div class="attr-content">
                <div class="f--c" v-for="(attr, y) in attrs.attrValueConfigList" :key="y">
                  <div class="attr-content-title">{{ attr.attrValueName }} <span class="number">{{ attr.productNum }}</span></div>
                  <div class="attr-content-edit">
                    <el-checkbox v-model="attr.isAggregation" :true-label="1" :false-label="0" @change="(e) => setSiteMapConfig(e, [attr.id], 'aggregation')"></el-checkbox>
                    <span :class="attr.isSeoData ? 'circle circled' : 'circle'"></span><span class="edit" @click="editSeoInfo(attr.uniqueUrl)">编辑</span>
                  </div>
                  <el-checkbox v-model="attr.isInternalLink" :true-label="1" :false-label="0"  @change="(e) => setSiteMapConfig(e, [attr.id], 'internalLink')"></el-checkbox>
                </div>
              </div>
            </div>
            <template v-if="item.attrList.length%5===1"><div class="attrs"></div><div class="attrs"></div><div class="attrs"></div><div class="attrs"></div></template>
            <template v-else-if="item.attrList.length%5===2"><div class="attrs"></div><div class="attrs"></div><div class="attrs"></div></template>
            <template v-else-if="item.attrList.length%5===3"><div class="attrs"></div><div class="attrs"></div></template>
            <template v-else-if="item.attrList.length%5===4"><div class="attrs"></div></template>
          </div>
        </el-collapse-item>
      </template>
    </el-collapse>

    <!-- 添加/编辑品类 -->
    <el-dialog title="编辑聚合页" :visible.sync="categoryDialogVisible" width="60%" :before-close="closeCategoryDialog" class="addOrEdit">
      <el-form ref="form" label-position="right" :model="seoInfo" :rules="rules" label-width="100px">
        <div class="flex-container">
          <el-form-item class="form-item" label="SEO标题：" prop="seoTitle">
            <div class="f--c">
              <el-input v-model.trim="seoInfo.seoTitle" size="medium" :maxlength="150" placeholder="请输入SEO标题" @input="handleInput()" style="width:500px" />
              <div style="flex-shrink: 0;padding:0 10px">1/150</div>
            </div>
          </el-form-item>
          <el-form-item class="form-item right" label="SEO描述：" prop="seoDescription">
            <div class="f--c">
              <el-input v-model.trim="seoInfo.seoDescription" size="medium" :maxlength="50" placeholder="请输入SEO描述" @input="handleInput()" style="width:500px" />
              <div style="flex-shrink: 0;padding:0 10px">1/150</div>
            </div>
          </el-form-item>
          <el-form-item class="form-item" label="SEO关键词：" prop="seoKeyWords">
            <div class="f--c">
              <el-input v-model.trim="seoInfo.seoKeyWords" size="medium" :maxlength="150" placeholder="请输入SEO关键词" @input="handleInput()" style="width:500px" />
              <div style="flex-shrink: 0;padding:0 10px">1/150</div>
            </div>
          </el-form-item>
          <el-form-item class="form-item right" label="网址：" prop="businessId">
            <div class="f--c">
              <span>{{ seoInfo.businessId }}</span>
            </div>
          </el-form-item>
          <el-form-item label="页面描述:" prop="pageDescription">
            <rich-editor v-model.trim="seoInfo.pageDescription" :value="seoInfo.pageDescription" style="width:100%"/>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeCategoryDialog">取 消</el-button>
        <el-button size="medium" type="primary" @click="confirmDialogVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
// import { getPathName } from '@/utils'
import _ from 'lodash'
import RichEditor from '@/views/operation/copywriting/components/RichEditor.vue'

const seo = {
  seoTitle: '',
  seoDescription: '',
  seoKeyWords: '',
  businessId: '',
  pageDescription: '',
  type: 4,
  seoSearchTerm: ''
}
export default {
  components: {
    RichEditor
  },
  data() {
    return {
      loading: true,
      categorys:[],
      activeNames: [0],
      categoryAttrs: [],
      categoryDialogVisible: false,
      seoInfo: seo,
      activeName: '',
      firstCategory: '',
      rules: {
        // 添加/编辑品类对话框中表单的验证对象
        seoTitle: [
          { required: true, message: '请输入通用英语的材质', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符之间', trigger: 'blur' }
        ],
        businessId: [
          { required: true, message: '请输入网址', trigger: 'blur' },
        ],
        pageDescription: [
          { required: true, message: '请输入页面描述', trigger: 'blur' },
        ]
      },
    }
  },
  created() {
    this.categoryTabs()
  },
  mounted() {
    
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    closeCategoryDialog() {
      this.categoryDialogVisible = false
    },
    categoryTabs(tab = '') {
      this.loading = true
      API.getCategory().then((res) => {
        this.categorys = res.data
        let firstCategory = tab !== '' ? tab.name : this.categorys.length > 0 ? this.categorys[0].firstCategoryName : ''
        if (firstCategory !== '') this.siteMapConfigList(firstCategory)
      }).catch(res => {
        console.log(res)
      })
    },
    sitemap() {
      API.getCategory().then((res) => {
        this.categorys = res.data
        let firstCategory = this.categorys.length > 0 ? this.categorys[0].firstCategoryName : ''
        if (firstCategory !== '') this.siteMapConfigList(firstCategory)
      }).catch(res => {
        console.log(res)
      })
    },
    confirmDialogVisible() {
      this.seoInfo.seoSearchTerm = this.seoInfo.businessId
      API.putSeoInfo(this.seoInfo).then((res) => {
        console.log(res.data)
        this.$message.success('编辑成功')
        this.categoryDialogVisible = false
      }).catch(res => {
        console.log(res)
      })
    },
    siteMapConfigList(firstCategory) {
      this.activeName = firstCategory
      API.siteMapConfigList({firstCategoryName:firstCategory}).then((res) => {
        res.data.lastStageCategoryList.forEach((item) => {
          item.attrList.forEach((attrs) => {
            attrs.isAggregation = 1
            attrs.isInternalLink = 1
            attrs.attrValueConfigList.forEach((attr) => {
              if(attr.isAggregation === 0) {
                attrs.isAggregation = 0
              }
              if(attr.isInternalLink === 0) {
                attrs.isInternalLink = 0
              }
            })
          })
        })
        this.categoryAttrs = res.data
        this.loading = false
      }).catch(res => {
        console.log(res)
        this.loading = false
      })
    },
    setSiteMapConfig(e, id, type) {
      let param = {ids: id}
      if(e) {
        param.isAggregation = 1
        if(type === 'internalLink') param.isInternalLink = 1
      } else {
        param.isInternalLink = 0
        if(type === 'aggregation') param.isAggregation = 0
      }
      API.siteMapConfig(param).then((res) => {
        this.categoryTabs({name:this.activeName})
      }).catch(res => {
        console.log(res)
      })
    },
    setSiteMapConfigAll(e, type, i, x) {
      let ids = []
      this.categoryAttrs.lastStageCategoryList.forEach((item, index) => {
        if(index === i) {
          item.attrList.forEach((item1, index1) => {
            if(index1 === x) {
              item1.attrValueConfigList.forEach((v, i) => {
                if(e) { // 全选
                  type === 'aggregation' ? v.isAggregation = 1 : v.isInternalLink = 1
                } else {
                  type === 'aggregation' ? v.isAggregation = 0 : v.isInternalLink = 0
                }
                ids.push(v.id)
              })
            }
          })
        }
      })
      this.setSiteMapConfig(e, ids, type)
    },
    editSeoInfo(businessId) {
      API.seoTitle({type: 4, businessId: businessId}).then((res) => {
        this.seoInfo = res.data === undefined ? seo : res.data
        this.seoInfo.businessId = businessId
        this.categoryDialogVisible = true
      }).catch(res => {
        console.log(res)
      })
    },
    handleInput(val) {

    }
  }
}
</script>

<style lang="scss" scoped>
.category-list {
  li {
    float: left;
    padding: 0 20px 0 0;
    cursor: pointer;
  }
}
.categorys {
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  width: 100%;
  .attrs {
    display: inline-block;
    width: 19%;
    margin-bottom: 20px;
    .attr-title {
      display: flex;
      justify-content: space-between;
      padding: 4px;
    }
    .attr-content {
      border: 1px solid #94a3b8;
      height: 300px;
      padding: 4px 8px 4px 4px;
      overflow-y: scroll;
      .f--c {
        justify-content: space-between;
      }
      .attr-content-title {
        width: 50%;
        color: #8c8a88;
      }
      .number {
        color: #c1c9da;
      }
      .attr-content-edit {
        .edit {
          color: #bbd867;
          cursor: pointer;
        }
        .circle {
          width: 8px;
          height: 8px;
          display: inline-block;
          border: 1px solid #bbd867;
          border-radius: 8px;
          margin: 0 4px;
        }
        .circled {
          background: #bbd867;
        }
        /deep/ .el-checkbox__label{
          color: #bbd867;
        }
      }
      /deep/ .el-checkbox__inner{
        border-color: #bbd867 !important;
      }
    }
  }
}

/deep/ .form-item {
  width: 48%;
  display: inline-block;
}
/deep/ .right {
  float: right;
}
</style>
